import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import GasOrder from '../views/GasOrder.vue'
import Tracing from '../views/Tracing.vue'
import Waiting from '../views/Waiting.vue'
import Qualify from '../views/Qualify.vue'
import Terminos from '../views/TerminosCondiciones.vue'
import Aviso from '../views/AvisoPrivacidad.vue'
import Faq from '../views/Faq'
import OrderCreated from "../views/OrderCreated";
Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/pedirgas',
    name: 'GasOrder',
    component: GasOrder
  },
  {
    path: '/seguimiento',
    name: 'Tracing',
    component: Tracing
  },
  {
    path: '/reserva',
    name: 'Waiting',
    component: Waiting
  },
  {
    path: '/calificar',
    name: 'Qualify',
    component: Qualify
  },
  {
    path: '/terminos',
    name: 'Terminos',
    component: Terminos
  },
  {
    path: '/politicas',
    name: 'Politicas',
    component: Aviso
  },
  {
    path: '/faq',
    name: 'Faq',
    component: Faq
  },
  {
    path: '/pedidoexitoso',
    name: 'PedidoExitoso',
    component: OrderCreated
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
